module.exports = __webpack_public_path__ + "img/corenroll-logo-dark.0690873e.png";